{
  "title": "What's on your mind?",
  "modeSelect": {
    "title": "How do you want to get started?",
    "braindump": "Just let me dump it all",
    "braindumpDesc": "Paste or type everything that's floating around in your head. I'll sort it out.",
    "conversational": "Ask me questions",
    "conversationalDesc": "I'll ask what's bugging you and pull out the important stuff."
  },
  "braindump": {
    "title": "Brain dump",
    "placeholder": "Write everything that's on your mind. Tasks, worries, reminders, half-thoughts — all of it.",
    "submit": "Extract items"
  },
  "conversational": {
    "title": "Let's talk it through",
    "systemStart": "What's been bugging you the most lately?",
    "placeholder": "Type your response...",
    "send": "Send",
    "done": "That's enough for now"
  },
  "confirmation": {
    "title": "Here's what I found",
    "subtitle": "Review and adjust before adding these to your system.",
    "empty": "No items were extracted. Try again with more detail.",
    "addAll": "Add all items",
    "removeItem": "Remove",
    "warming": "Has a deadline",
    "cooling": "No deadline",
    "category": "Category",
    "consequence": "Consequence",
    "effort": "Effort",
    "anchor": "Due"
  }
}
